import { useMemo } from 'react';

import { EMPTY_ARRAY } from '@e-socna/empty';

import { useFindAllExternalOrganizationsQuery } from '../../../components/ThirdParties/hooks/useFindAllExternalOrganizationsQuery.hook';

import { buildExistingOrganizationIdentifiers } from '../mappers/existing-organization-identifiers.mapper';

export const useExistingOrganizationIdentifiers = (): ReadonlySet<string> => {
  const { data } = useFindAllExternalOrganizationsQuery();

  return useMemo(
    () =>
      buildExistingOrganizationIdentifiers(
        data?.findSomeOrganizations ?? EMPTY_ARRAY,
      ),
    [data],
  );
};
